import htmlTruncate from 'html-truncate';
import { useState } from 'react';
import 'react-quill/dist/quill.snow.css';

import Button from 'primitives/Button';
import { Dialog, DialogActions, DialogPanel, DialogTitle } from 'primitives/Dialog';

const ReadMoreWithDialog = ({ content }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const previewLength = 600;

  const openDialog = () => setIsDialogOpen(true);

  const closeDialog = () => setIsDialogOpen(false);

  const previewText = htmlTruncate(content, previewLength, { keepImageTag: true });
  const isLongText = previewText !== content;

  return (
    <div>
      <div className="ql-container ql-snow">
        <div className="ql-editor" dangerouslySetInnerHTML={{ __html: previewText }} />
      </div>

      {isLongText && (
        <Button
          variant="text"
          onClick={openDialog}
          className="text-indigo-600 hover:underline mt-2"
        >
          Read More
        </Button>
      )}

      <Dialog open={isDialogOpen} onClose={closeDialog}>
        <DialogPanel className="sm:!max-w-3xl">
          <DialogTitle>Full Memo</DialogTitle>
          <div className="ql-container ql-snow">
            <div className="ql-editor" dangerouslySetInnerHTML={{ __html: content }} />
          </div>

          <DialogActions className="sm:grid-cols-1">
            <Button onClick={closeDialog}>Close</Button>
          </DialogActions>
        </DialogPanel>
      </Dialog>
    </div>
  );
};

export default ReadMoreWithDialog;
